import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { Component, OnDestroy } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { PlotlyService } from 'angular-plotly.js';
import { Subscription } from 'rxjs';
import * as PlotlyPLLocale from 'src/assets/plotly-locale-pl.js';
import { IconService } from './common/service/icon.service';
import { LangService } from './common/service/lang.service';
import { LiveDataReportService } from './common/service/live-data-report.service';
import { ToastService } from './common/service/toast.service';
import { UserFilesService } from './common/service/user-files.service';
import { UserTokenService } from './common/service/user-token.service';
import { WebsocketClient } from './common/service/websocket-client.service';
import { KeycloakInit } from './keycloak/keycloak-init';
import { UpdateTokenEvent } from './keycloak/update-token-event';
import { UserSettingsService } from './settings/service/user-settings.service';
import { AlcoholTestNotifierService } from './vehicles/service/alcohol-test-notifier.service';
import { SnapshotNotifierService } from './vehicles/service/snapshot-notifier-service';
import { DateAdapter } from '@angular/material/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [PlotlyService]
})
export class AppComponent implements OnDestroy {

  private serverConnectionSnackBar?: MatSnackBarRef<any>;

  private sessionExpiredToastShown = false;
  private updateTokenSubscription?: Subscription;
  private langChangeSubscription?: Subscription;

  constructor(router: Router, private keycloak: KeycloakInit, langService: LangService,
    public userSettings: UserSettingsService, datetTimeAdapter: NgxMatDateAdapter<any>,
    private plotlyService: PlotlyService, private userFilesService: UserFilesService,
    private userTokenService: UserTokenService, iconService: IconService, private liveDataReportService: LiveDataReportService,
    private snapshotNotifierService: SnapshotNotifierService, private alcoholTestResponseNotifier: AlcoholTestNotifierService,
    private wsClient: WebsocketClient, dateAdapter: DateAdapter<unknown>, private toast: ToastService) {

    datetTimeAdapter.setLocale(langService.getLanguage());
    dateAdapter.setLocale(langService.getLanguage());
    this.langChangeSubscription = langService.langChange$.subscribe(newLang => {
      datetTimeAdapter.setLocale(newLang);
      dateAdapter.setLocale(newLang);
    });
    void this.setupPlotty();
    iconService.init();

    if (userSettings.isSettingsLoaded()) {
      this.initApp();
    } else {
      void router.navigate(['/error-500'], { skipLocationChange: true });
    }
  }

  private async setupPlotty(): Promise<void> {
    const plotly = await this.plotlyService.getPlotly();
    plotly.register(PlotlyPLLocale);
  }

  ngOnDestroy(): void {
    this.updateTokenSubscription?.unsubscribe();
    this.langChangeSubscription?.unsubscribe();
    this.serverConnectionSnackBar?.dismiss();
    this.snapshotNotifierService.userSnapshotFilesSubscription?.unsubscribe();
    this.alcoholTestResponseNotifier.unsubscribe();
    this.wsClient.disconnect();
  }

  private initApp(): void {
    this.addUpdateTokenSubscriber();
    this.wsClient.init();
    this.userFilesService.init();
    this.liveDataReportService.init();
    this.userTokenService.init();
    this.snapshotNotifierService.init();
    this.alcoholTestResponseNotifier.init();
  }

  private addUpdateTokenSubscriber(): void {
    this.updateTokenSubscription = this.keycloak.updateToken$.subscribe(updateEvent => {
      if ((updateEvent == UpdateTokenEvent.EXPIRED_ERROR || updateEvent == UpdateTokenEvent.TIMEOUT) && this.sessionExpiredToastShown == false) {
        this.toast.showStickyToast('error', null, 'sessionExpired', null);
        this.sessionExpiredToastShown = true;
      }

      if (updateEvent == UpdateTokenEvent.SUCCESS && this.sessionExpiredToastShown == true) {
        this.sessionExpiredToastShown = false;
      }
    });
  }

}
